
import {
  CategoryFragment,
  PostFragment,
  TreatmentFragment,
} from "../interfaces";
import classNames from "../lib/classNames";
import PostCard from "./PostCard";
import PostListing from "./PostListing";

type Props = {
  category: CategoryFragment;
  posts: PostFragment[];
  treatments: TreatmentFragment[];
};

const Category = ({ category, posts, treatments }: Props) => {
  return (
    <div className="bg-white">
      <div className="relative py-12 overflow-hidden ">
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="mx-auto text-lg max-w-prose">
            <h1 className="block mt-2 text-3xl font-extrabold leading-8 tracking-tight text-center text-gray-900 sm:text-4xl">
              {category.name}
            </h1>
            {category.description && (
              <p className="mt-8 text-xl leading-8 text-gray-500">
                {category.description}
              </p>
            )}
          </div>
        </div>
      </div>
      {treatments.length > 0 && (
        <div className="relative px-4 pt-4 pb-20 bg-gray-50 sm:px-6 lg:pt-14 lg:pb-28 lg:px-8">
          <div className="relative mx-auto max-w-7xl">
            <div
              className={classNames(
                treatments.length < 3 ? "lg:grid-cols-2" : "lg:grid-cols-3",
                "grid max-w-lg gap-5 mx-auto mt-12 lg:max-w-none"
              )}
            >
              {treatments.map(({ __typename, ...treatment }) => (
                <PostCard key={treatment.id} post={treatment} />
              ))}
            </div>
          </div>
        </div>
      )}
      <div>
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="relative z-10 flex items-baseline justify-between pt-12 pb-6 border-b border-gray-200">
            <h1 className="mx-auto text-4xl font-extrabold tracking-tight text-center text-gray-900">
              {category.name} Articles
            </h1>
          </div>
          <section aria-labelledby="posts" className="pt-6 pb-24">
            <div className="flex flex-col">
              {/* Product grid */}
              {posts.map((post) => (
                <PostListing post={post} key={post.id} />
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Category;
